import React, { useCallback, useContext, useEffect, useState } from "react";
import { Container } from "components";
import Breadcrumb from "components/molecules/Breadcrumb";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getData, patchData } from "actions";
import { API_URL_apiSetting } from "constants/api";
import { apiSettingReducers } from "redux/apiSettingSlice";
import { AuthContext } from "context/AuthContext";

const Debugging = () => {
  const navigate = useNavigate();
  const [adminAccess, setAdminAccess] = useState(false);
  const { datauser } = useContext(AuthContext);
  const dispatch = useDispatch();
  const [debuggingMode, setDebuggingMode] = useState("");
  const [sendCrashInfo, setSendCrashInfo] = useState("");

  const { getApiSettingResult, addApiSettingResult } = useSelector(
    (state) => state.apiSetting
  );

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_apiSetting,
        params,
        { dispatch, redux: apiSettingReducers },
        "GET_APISETTING"
      );
    },
    [dispatch]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = [
      { key: "debugging_mode", value: debuggingMode },
      { key: "send_crash_info", value: sendCrashInfo },
    ];
    //edit
    patchData(
      `${API_URL_apiSetting}patch/`,
      formData,
      { dispatch, redux: apiSettingReducers },
      "ADD_APISETTING",
      () => {
        fetchData();
        navigate("/administrator/errorlogsdebugging/debuggingoptions");
      }
    );
  };

  const fetchData = useCallback(() => {
    //get all of Apisetting
    const params = ``;
    get(params);
  }, [get]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (addApiSettingResult) {
      fetchData();
    }
  }, [addApiSettingResult]);

  useEffect(() => {
    //getApiSettingResult get all key & value
    if (getApiSettingResult) {
      const apiSettings = {};
      getApiSettingResult.forEach((item) => {
        apiSettings[item.key] = item.value;
      });

      setDebuggingMode(apiSettings["debugging_mode"]);
      setSendCrashInfo(apiSettings["send_crash_info"]);
    }
  }, [getApiSettingResult]);

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );
      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }

  return (
    <Container>
      <Breadcrumb
        title={"Error logs and debugging"}
        excludedPaths={["errorlogsdebugging", "administrator"]}
        group={"Superadmin"}
      />
      <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow">
        <div className="h-12 w-full grid items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600 text-xs md:text-base">
          Debugging options
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mt-4 grid grid-cols-12 gap-10 h-auto w-auto px-4 bg-neutral dark:bg-neutral-800 border-b border-neutral-200 dark:border-neutral-600 object-left">
            <div className="col-span-full md:col-start-1 md:col-span-5 lg:col-start-1 lg:col-span-5">
              <label className="text-xs md:-text-sm lg:text-sm">
                Debugging mode
              </label>
              <div className="flex flex-wrap">
                <label className="items-center mt-2 text-xs md:-text-sm lg:text-sm">
                  <input
                    id="debuggingMode1"
                    type="radio"
                    name="debuggingMode"
                    checked={debuggingMode === "1"}
                    onChange={() => setDebuggingMode("1")}
                    className="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                  />
                  <span className="ml-2 mr-5">Enable</span>
                </label>
                <label className="items-center mt-2 text-xs md:-text-sm lg:text-sm">
                  <input
                    id="debuggingMode0"
                    type="radio"
                    name="debuggingMode"
                    checked={debuggingMode === "0"}
                    onChange={() => setDebuggingMode("0")}
                    className="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                  />
                  <span className="ml-2">Disable</span>
                </label>
              </div>
            </div>
          </div>

          <div className="h-12 w-full grid items-center px-4 bg-neutral-50 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="w-20 items-center p-1 px-3 rounded shadow-sm border text-white bg-blue-800 hover:bg-blue-700"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </Container>
  );
};

export default Debugging;
